import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-fecal-scoring',
  templateUrl: './fecal-scoring.component.html',
  imports: [RouterOutlet],
})
export class FecalScoringComponent {}
